import { z } from 'zod';

export const AiSkillCategorySchema = z.enum([
  'authorization',
  'coding',
  'documentation',
  'claims',
  'clinical',
  'eligibility',
  'integration',
]);

export type AiSkillCategory = z.infer<typeof AiSkillCategorySchema>;

export const AI_SKILL_CATEGORY_LABELS: Record<AiSkillCategory, string> = {
  authorization: 'Prior Authorization',
  coding: 'Coding & Billing',
  documentation: 'Documentation',
  claims: 'Claims',
  clinical: 'Clinical',
  eligibility: 'Eligibility',
  integration: 'EMR Integrations',
};

export const AiSkillStarterPromptSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  prompt: z.string(),
  gradient: z.string().optional(),
});

export type AiSkillStarterPrompt = z.infer<typeof AiSkillStarterPromptSchema>;

export const AiSkillSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  tagline: z.string(),
  description: z.string(),
  category: AiSkillCategorySchema,
  icon: z.string(),
  accentColor: z.string(),
  placeholder: z.string(),
  systemPrompt: z.string(),
  outputFormatPrompt: z.string(),
  starterPrompts: z.array(AiSkillStarterPromptSchema).min(3),
  source: z.enum(['system', 'org', 'user']).default('system'),
  enabled: z.boolean().default(true),
  version: z.number().int().default(1),
});

export type AiSkill = z.infer<typeof AiSkillSchema>;

/**
 * Wire-safe skill: strips server-only fields (systemPrompt, outputFormatPrompt)
 * before sending to the client over the /ai-skills API.
 */
export const AiSkillPublicSchema = AiSkillSchema.omit({
  systemPrompt: true,
  outputFormatPrompt: true,
});

export type AiSkillPublic = z.infer<typeof AiSkillPublicSchema>;
